import { fabric } from "fabric";

export interface CreateTextParams {
  left: number;
  top: number;
  text?: string;
  fontSize: number;
  editable?: boolean;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  fontFamily?: string;
  angle?: number;
  visible?: boolean;
}

export class TextFactory {
  static create({
    left,
    top,
    text = "",
    fontSize,
    editable = true,
    fill = "#000000",
    stroke = "#000000",
    strokeWidth = 0,
    fontFamily = "Roboto",
    angle = 0,
    visible = true,
  }: CreateTextParams) {
    const fabricText = new fabric.Text(text, {
      left,
      top,
      fontSize,
      fill,
      stroke,
      strokeWidth,
      fontFamily,
      angle,
      originX: "center",
      originY: "center",
      type: "text",

      // interacción
      hasControls: editable,
      hasBorders: editable,
      selectable: editable,
      lockMovementX: !editable,
      lockMovementY: !editable,

      strokeUniform: true,
      visible,
    });

    return fabricText;
  }
}